import { Config } from '../config';
import { BulkEventEditJob, BulkEventEditJobAction, BulkEventEditJobsListResponse, CreateBulkEventEditJobResponse } from '../interfaces';
import { HttpService } from './http.service';

const path = `${Config.API}/api/v2/bulk-event-edit-jobs`;

export abstract class BulkEventEditJobService {
  public static listJobs = (limit: number, offset: number, status?: string): Promise<BulkEventEditJobsListResponse> => {
    const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
    if (status) {
      params.set('status', status);
    }

    return HttpService.fetchAuthorized(`${path}?${params}`).then((res) => res || { jobs: [], total_count: 0 });
  };

  public static createJob = (action: BulkEventEditJobAction, jiraWorkItem: string): Promise<CreateBulkEventEditJobResponse> => {
    return HttpService.fetchAuthorized(path, {
      method: 'POST',
      body: JSON.stringify({ action, jira_work_item: jiraWorkItem }),
    }).then((res) => res);
  };

  public static runJob = (jobUUID: string, force?: boolean): Promise<BulkEventEditJob> => {
    return HttpService.fetchAuthorized(`${path}/${jobUUID}`, {
      method: 'POST',
      body: JSON.stringify({ force: force ?? false }),
    }).then((res) => res);
  };

  // Plain fetch — no Authorization header. S3 presigned PUT URLs must not include extra auth headers.
  public static uploadCsv = (presignedUrl: string, file: File): Promise<void> => {
    return fetch(presignedUrl, {
      method: 'PUT',
      body: file,
    }).then((res) => {
      if (!res.ok) {
        throw new Error(`CSV upload failed with status ${res.status}`);
      }
    });
  };
}
